import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import DefaultButton from 'components/Utils/NewDefaultButton';
import { useAppDispatch } from 'careand-redux/useAppDispatch';
import { api } from 'careand-redux/api/ApiThunks';
import DefaultTextField from 'components/Utils/DefaultTextField';
import { ohipFieldsSchema, OHIPFieldsValues } from 'types/forms';
import { getTenantProvince } from 'services/portalData';

const EditOHIP = ({ patient, onSuccess }: { patient: any; onSuccess?: () => void }) => {
  const dispatch = useAppDispatch();
  const [loading, setLoading] = useState(false);
  const [loadingRemove, setLoadingRemove] = useState(false);

  const { control, handleSubmit } = useForm<OHIPFieldsValues>({
    resolver: zodResolver(ohipFieldsSchema),
    defaultValues: { health_number: '' },
  });

  async function updateOhip(values: OHIPFieldsValues) {
    setLoading(true);
    const result = await dispatch(
      api.Patients.updateHealthCard({
        patientId: patient.id,
        healthCard: { province: getTenantProvince(), ...values },
      }),
      {
        errorTitle: 'OHIP Update',
      },
    );
    setLoading(false);
    if (result && onSuccess) onSuccess();
  }

  async function removeOhip() {
    setLoadingRemove(true);
    await dispatch(api.Patients.removeHealthCard({ patientId: patient.id }), {
      errorTitle: 'OHIP Update',
    });
    setLoadingRemove(false);
  }

  return (
    <div>
      <DefaultTextField
        name="health_number"
        control={control}
        label="OHIP Number"
        className="with-errors"
        placeholder="OHIP Number (Example: 1234567890YM)"
        disabled={loading}
      />
      <DefaultButton
        name="Remove OHIP"
        className="red"
        style={{ marginRight: '15px', marginTop: '20px' }}
        hide={patient.health_card?.health_number === undefined}
        loading={loadingRemove}
        onClick={removeOhip}
      />
      <DefaultButton
        name="Save OHIP Number"
        style={{ marginTop: '20px', width: '170px' }}
        className="blue"
        loading={loading}
        onClick={handleSubmit(updateOhip)}
      />
    </div>
  );
};

export default EditOHIP;
